<!-- <div class="row first-row">
  <custom-menu position="footer" class="first-menu first-col" [horizontal]="true"></custom-menu>
  <custom-menu position="footer-secondary" class="second-menu second-col" [horizontal]="true"></custom-menu>
</div> -->
<div class="background">
  <div class="container">
  <div class="columns">
    <div class="column">
      <a
        routerLink="/"
        class="logo-container img-logo-container"
        *ngIf="settings.get('branding.logo_light')"
      >
        <img
          class="logo"
          [alt]="'Site logo' | trans"
          [src]="settings.get('branding.logo_light')"
          style="margin-bottom: 20px"
        />
      </a>
      <br />
      <a
        href="https://jio.sh/ObpVM"
        target="_blank"
        class="icon-button twitter"
      >
        <img
          style="height: 46px; display: block;margin-left: 0px;"
          src="/client/assets/icons/twitter-x.png" 
        />
      </a>
      <!-- <a href="https://jio.sh/9dQBc" target="_blank" class="icon-button whatsapp"
        ><i class="fa fa-whatsapp"></i><span></span
      ></a> -->
      <a href="https://jio.sh/url" target="_blank" class="icon-button jiosh"
        ><img
          style="height: 51px; display: block;margin-left: 0px;"
          src="/client/assets/icons/JioShURL_icon-512_200x200.ico" /><span></span
      ></a>
      <a
        href="https://jio.sh/eozOq"
        target="_blank"
        class="icon-button facebook"
        ><i class="fa fa-facebook"></i><span></span
      ></a>
      <br />
      <a
        href="https://jio.sh/mhAgg"
        target="_blank"
        class="icon-button instagram"
        ><i class="fa fa-instagram"></i><span></span
      ></a>
      <!-- <a href="https://jio.sh/gG2ZQ" target="_blank" class="icon-button telegram"
        ><i class="fa fa-telegram"></i><span></span
      ></a> -->
      <a
        href="https://jio.sh/XXLZZ"
        target="_blank"
        class="icon-button linkedin"
        ><i class="fa fa-linkedin"></i><span></span
      ></a>
      <br />
      <a
        href="https://jio.sh/HkG7a"
        target="_blank"
        class="icon-button youtube"
        ><i class="fa fa-youtube"></i><span></span
      ></a>
      
      <!-- <a href="https://jio.sh/XmLUN" target="_blank" class="icon-button">
        <img
            style="height: 51px; display: block;margin-left: 0px;"
            src="/client/assets/icons/threads.png" 
        />
        <span></span>
      </a> -->
    </div>
    <div class="column">
      <p style="color: #595a5e; font-weight: 600; font-size: 20px">
        ChatBot Support
      </p> 
      <p>
        <a href="https://t.me/JioShURLBot" target="_blank" class="chatlink"
          ><i class="fa fa-telegram"></i> Telegram</a
        >
      </p>
      <p>
        <a
          href="https://twitter.com/messages/compose?recipient_id=1410639908738244612&text=Hi"
          target="_blank"
          class="chatlink"
          ><i class="fa fa-twitter"></i> Twitter</a
        >
      </p>
      <p>
        <a href="https://m.me/JioShURL" target="_blank"
        class="chatlink"
          ><i class="fa fa-facebook"></i> Facebook</a
        >
      </p>
      <p>
        <a href="https://ig.me/m/jioshurl" target="_blank"
        class="chatlink"
          ><i class="fa fa-instagram"></i> Instagram</a
        >
      </p>
    </div>
    <div class="column">
      <p style="color: #595a5e; font-weight: 600; font-size: 20px">Management</p>
      <p class="footer-link" *ngIf="shouldShow('auth')" (click)="api()">API</p>
      <!-- <p class="footer-link" >PWA</p> -->
      <p class="footer-link" (click)="url()">JioSh URL Button</p>
      <p class="footer-link" (click)="subscribe()">Subscribe Newsletter</p>
      <p class="footer-link" (click)="unsubscribe()">Unsubscribe Newsletter</p>
      <p class="footer-link" (click)="helpRegister()">How to Register on JioSh</p>
      <p class="footer-link" (click)="helpLogin()">How to Login on JioSh</p>
    </div>
    <div class="column">
      <p style="color: #595a5e; font-weight: 600; font-size: 20px">JioSh URL</p>
      <p class="footer-link" (click)="aboutUs()">About Us</p>
      <p class="footer-link" (click)="support()">Support</p>
      <p class="footer-link" (click)="terms()">Terms of service</p>
      <p class="footer-link" (click)="policy()">Privacy</p>
      <p class="footer-link" (click)="tnc()">Terms & Conditions</p>
      <p class="footer-link" (click)="refund()">Refund Policy</p>
      <p class="footer-link" (click)="compliance()">Compliance Statement</p>
      <p class="footer-link" (click)="cookiePolicy()">Cookie Policy</p>
    </div>
    </div>
  </div>
  </div>
  
  <div class="bottom-footer">
    <div class="copyright">
      {{ copyrightText }}
    </div>
    <div class="selectors">
      <button
        type="button"
        mat-button
        style="color: white"
        class="button-with-icon"
        (click)="theme.toggle()"
        *ngIf="settings.get('themes.user_change')"
      >
        <ng-container
          *ngIf="(theme.selectedTheme$ | async)?.is_dark; else lightMode"
        >
          <mat-icon svgIcon="light-mode"></mat-icon>
          <span trans>Light Mode</span>
        </ng-container>
        <ng-template #lightMode>
          <mat-icon svgIcon="dark-mode"></mat-icon>
          <span trans>Dark Mode</span>
        </ng-template>
      </button>
  
      <button
        type="button"
        class="button-with-icon"
        style="color: white"
        [matMenuTriggerFor]="menu"
        mat-button
        [disabled]="changingLang$ | async"
        (menuOpened)="langMenuOpened()"
      >
        <mat-icon svgIcon="language"></mat-icon>
        <span trans>{{ i18n.localization?.model?.name || "English" }}</span>
      </button>
      <mat-menu #menu="matMenu">
        <button
          mat-menu-item
          class="capitalize"
          *ngFor="let loc of localizations$ | async"
          (click)="changeLanguage(loc)"
          trans
        >
          <mat-icon
            svgIcon="check"
            [class.invisible]="!i18n.isActive(loc)"
          ></mat-icon>
          {{ loc.name }}
        </button>
      </mat-menu>
    </div>
  </div>
  